import { gql, TypedDocumentNode } from '@apollo/client'
import { countryFragment } from './CountryFragment'
import { offerFragment } from './OfferFragment'
import type { CompanyFragment } from './__generated__/CompanyFragment'

export const companyFragment: TypedDocumentNode<CompanyFragment> = gql`
  ${countryFragment}
  ${offerFragment}

  fragment CompanyFragment on Company {
    buildingNumber
    city
    connexysId
    costPlacesEnabled
    country {
      ...CountryFragment
    }
    createdAt
    hasNonPayrollOffers
    id
    logo
    name
    offers {
      ...OfferFragment
    }
    officialName
    oldStyleOffersExist
    ownerId
    referralCode
    street
    streetNumber
    vat
    website
    zip
  }
`
